module.exports = __webpack_public_path__ + "img/free-shipping.7dac0b5c.svg";